import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // ✅ Use context
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logout } = useAuth(); // ✅ Get auth state and logout function
  const [menuOpen, setMenuOpen] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);

  const isDashboard = location.pathname.includes('dashboard');
  const getHomePath = () => {
    const role = currentUser?.role;
    if (role === 'superuser') return '/superuser-dashboard';
    if (role === 'admin') return '/admin-dashboard';
    if (role === 'teacher') return '/teacher-dashboard';
    return '/';
  };
  const homePath = getHomePath();

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const handleAppInstalled = () => {
      setInstallPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    try {
      await installPrompt.userChoice;
    } finally {
      setInstallPrompt(null);
      setMenuOpen(false);
    }
  };

  const handleMenuClick = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const getNavLinkClass = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

  if (currentUser && isDashboard) {
    return null;
  }

  return (
    <nav className={`navbar${isDashboard ? ' navbar--dashboard' : ''}`}>
      <div className="navbar-left">
        <NavLink to={homePath} className="navbar-logo" onClick={handleMenuClick}>
          <img src="/logo.png" alt="MarkazSync Logo" className="navbar-logo-img" />
        </NavLink>

        {!isDashboard && (
          <button className="menu-toggle d-lg-none" onClick={toggleMenu}>
            <i className="bi bi-list" style={{ fontSize: '24px' }}></i>
          </button>
        )}
      </div>

      <ul className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
        <li>
          <NavLink to={homePath} className={getNavLinkClass} onClick={handleMenuClick} title="Home" aria-label="Home">
            <i className="bi bi-house-door" aria-hidden="true" />
            <span>Home</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/contact" className={getNavLinkClass} onClick={handleMenuClick} title="Contact Us" aria-label="Contact Us">
            <i className="bi bi-envelope" aria-hidden="true" />
            <span>Contact Us</span>
          </NavLink>
        </li>

        {installPrompt && (
          <li>
            <button onClick={handleInstall} className="nav-button nav-button--install" title="Install App" aria-label="Install App">
              <i className="bi bi-download" aria-hidden="true" />
              <span>Install App</span>
            </button>
          </li>
        )}

        {!currentUser ? (
          <li>
            <NavLink to="/" className={getNavLinkClass} onClick={handleMenuClick} title="Sign In" aria-label="Sign In">
              <i className="bi bi-box-arrow-in-right" aria-hidden="true" />
              <span>Sign In</span>
            </NavLink>
          </li>
        ) : (
          <li>
            <button onClick={handleLogout} className="nav-button" title="Logout" aria-label="Logout">
              <i className="bi bi-box-arrow-right" aria-hidden="true" />
              <span>Logout</span>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
